import { apiGet, apiPost, apiPatch, apiDelete } from './client';
import type { Department } from '../types';

export async function getDepartments(): Promise<Department[]> {
  return apiGet<Department[]>('/departments');
}

export async function createDepartment(data: { name: string; type: string }): Promise<Department> {
  return apiPost<Department>('/departments', data);
}

export async function updateDepartment(id: string, data: { name: string; type: string }): Promise<Department> {
  return apiPatch<Department>(`/departments/${id}`, data);
}

export async function deleteDepartment(id: string): Promise<void> {
  return apiDelete<void>(`/departments/${id}`);
}
